'use client';

import { useMemo } from 'react';
import { IconCompany } from '@/features/icons';
import SafeHtml from '@/components/safe-html';
import { cn } from '@/utils/cn';
import { getCdnUrl } from '@/utils/url';
import SectionHeading from './section-heading';
import { useLanguage } from '../context/language-context-provider';
const KhanoumiGroups = () => {
  const {
    t,
    language
  } = useLanguage();
  const isEn = language === 'en';
  const ITEMS = useMemo(() => [{
    title: t('groups.shop.title'),
    description: t('groups.shop.text'),
    icon: getCdnUrl('/_toad/images/about-us/khanoumi.svg')
  }, {
    title: t('groups.bazar.title'),
    description: t('groups.bazar.text'),
    icon: getCdnUrl('/_toad/images/about-us/khanoumi-bazar.svg')
  }, {
    title: t('groups.finance.title'),
    description: t('groups.finance.text'),
    icon: getCdnUrl('/_toad/images/about-us/khanoumi-finance.svg')
  }, {
    title: t('groups.business.title'),
    description: t('groups.business.text'),
    icon: getCdnUrl('/_toad/images/about-us/khanoumi-bussiness.svg')
  }, {
    title: t('groups.label.title'),
    description: t('groups.label.text'),
    icon: getCdnUrl('/_toad/images/about-us/private-label.svg')
  }, {
    title: t('groups.ads.title'),
    description: t('groups.ads.text'),
    icon: getCdnUrl('/_toad/images/about-us/beauty-ads.svg')
  }], [t]);
  return <div className='homepage-container lg:mt-30' data-sentry-component="KhanoumiGroups" data-sentry-source-file="khanoumi-groups.tsx">
            <div className='relative flex flex-col items-center gap-7 lg:pt-33'>
                <SectionHeading title={t('groups.title')} icon={<IconCompany />} className='lg:absolute lg:right-22 lg:top-0' data-sentry-element="SectionHeading" data-sentry-source-file="khanoumi-groups.tsx">
                    <span className='absolute -bottom-[68px] left-1/2 -z-10 hidden h-18 w-px bg-border-pink lg:inline-block' />
                </SectionHeading>

                <div className='grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-10'>
                    {ITEMS.map(({
          title,
          description,
          icon
        }, index) => {
          const isEven = index % 2 === 0;
          return <div key={index} className={cn('relative flex flex-col gap-2 rounded border border-border-pink py-3 lg:min-h-52', isEn ? {
            'ml-4 pl-8 pr-3 lg:ml-7 lg:pl-12': isEven,
            'mr-4 pl-3 pr-8 lg:mr-7 lg:pr-12': !isEven
          } : {
            'mr-4 pl-3 pr-8 lg:mr-7 lg:pr-12': isEven,
            'ml-4 pl-8 pr-3 lg:ml-7 lg:pl-12': !isEven
          })}>
                                <span className='text-body-16 font-medium lg:text-title-18 lg:font-bold'>{title}</span>
                                <SafeHtml as='p' content={description} className='text-caption-12 text-text-darkGray lg:text-body-16 [&>span]:font-medium [&>span]:text-black' />

                                <div className={cn('absolute top-5 flex flex-col items-center', isEn ? {
              'left-0 -translate-x-1/2': isEven,
              'right-0 translate-x-1/2': !isEven
            } : {
              'right-0 translate-x-1/2': isEven,
              'left-0 -translate-x-1/2': !isEven
            })}>
                                    <span className={cn('h-16 w-1.5 rounded-t bg-primary-main'
              // isEven ? 'translate-x-1/2 ltr:ml-auto' : '-translate-x-1/2 ltr:mr-auto'
              )} />
                                    <img src={icon} alt={title} className={cn('h-10 w-10 rounded-full bg-primary-main lg:h-14 lg:w-14'
              // isEven ? 'translate-x-1/2' : '-translate-x-1/2'
              )} />
                                </div>
                            </div>;
        })}
                </div>
            </div>
        </div>;
};
export default KhanoumiGroups;